// Human-readable display for raw catalog option values, e.g.
// "blueberry_and_coconut" → "Blueberry and Coconut". Display-only — never use the
// formatted value for filtering/tracking, those compare raw values.
const LOWERCASE_WORDS = new Set(["and", "or", "with", "of", "the"]);

export const formatLabel = (value) => {
  if (!value) return value;
  return String(value)
    .split(/[_-]+/)
    .map((word, i) =>
      i > 0 && LOWERCASE_WORDS.has(word.toLowerCase())
        ? word.toLowerCase()
        : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join(" ");
};
